import React, { PureComponent } from "react";
import SentenceTrendsEditButton from "./SentenceTrendsEditButton";

const DEFAULT_LINE1 = "3 Trends to Watch";
const DEFAULT_LINE1_SUBTITLE = "in Today's Market";

/**
 * Title + subtitle from `tpTrends2WatchList` / local draft.
 */
class SentenceTrendsHeader extends PureComponent {
  render() {
    const {
      titleMain,
      titleSub,
      showEditButton,
      onEditClick,
      isEdited,
      editDisabled,
    } = this.props;

    const main =
      titleMain != null && String(titleMain).trim() !== ""
        ? titleMain
        : DEFAULT_LINE1;
    const sub =
      titleSub != null && String(titleSub).trim() !== ""
        ? titleSub
        : DEFAULT_LINE1_SUBTITLE;

    return (
      <div className="sentence-trends-header-wrap">
        {showEditButton ? (
          <SentenceTrendsEditButton
            label="Edit Title & Area"
            isEdited={isEdited}
            onClick={onEditClick}
            disabled={editDisabled}
            className="sentence-trends-edit-btn-header"
          />
        ) : null}
        <div className="sentence-trends-db-header">
          <div className="sentence-trends-db-header-main">{main}</div>
          <div className="sentence-trends-db-header-mid">{sub}</div>
        </div>
      </div>
    );
  }
}

export default SentenceTrendsHeader;
